var _slicedToArray = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/defineProperty");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var utils = require('./utils');

var qs = require('querystring');

var _require = require('m3u8stream'),
    parseTimestamp = _require.parseTimestamp;

var BASE_URL = 'https://www.youtube.com/watch?v=';
var TITLE_TO_CATEGORY = {
  song: {
    name: 'Music',
    url: 'https://music.youtube.com/'
  }
};

var getText = function getText(obj) {
  return obj ? obj.runs ? obj.runs[0].text : obj.simpleText : null;
};
/**
 * Get video media.
 *
 * @param {Object} info
 * @returns {Object}
 */


exports.getMedia = function (info) {
  var media = {};
  var results = [];

  try {
    results = info.response.contents.twoColumnWatchNextResults.results.results.contents;
  } catch (err) {// Do nothing
  }

  var result = results.find(function (v) {
    return v.videoSecondaryInfoRenderer;
  });

  if (!result) {
    return {};
  }

  try {
    var metadataRows = (result.metadataRowContainer || result.videoSecondaryInfoRenderer.metadataRowContainer).metadataRowContainerRenderer.rows;

    var _iterator = _createForOfIteratorHelper(metadataRows),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var row = _step.value;

        if (row.metadataRowRenderer) {
          var title = getText(row.metadataRowRenderer.title).toLowerCase();
          var contents = row.metadataRowRenderer.contents[0];
          media[title] = getText(contents);
          var runs = contents.runs;

          if (runs && runs[0].navigationEndpoint) {
            media["".concat(title, "_url")] = new URL(runs[0].navigationEndpoint.commandMetadata.webCommandMetadata.url, BASE_URL).toString();
          }

          if (title in TITLE_TO_CATEGORY) {
            media.category = TITLE_TO_CATEGORY[title].name;
            media.category_url = TITLE_TO_CATEGORY[title].url;
          }
        } else if (row.richMetadataRowRenderer) {
          var _contents = row.richMetadataRowRenderer.contents;

          var boxArt = _contents.filter(function (meta) {
            return meta.richMetadataRenderer.style === 'RICH_METADATA_RENDERER_STYLE_BOX_ART';
          });

          var _iterator2 = _createForOfIteratorHelper(boxArt),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var richMetadataRenderer = _step2.value.richMetadataRenderer;
              var meta = richMetadataRenderer;
              media.year = getText(meta.subtitle);
              var type = getText(meta.callToAction).split(' ')[1];
              media[type] = getText(meta.title);
              media["".concat(type, "_url")] = new URL(meta.endpoint.commandMetadata.webCommandMetadata.url, BASE_URL).toString();
              media.thumbnails = meta.thumbnail.thumbnails;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var topic = _contents.filter(function (meta) {
            return meta.richMetadataRenderer.style === 'RICH_METADATA_RENDERER_STYLE_TOPIC';
          });

          var _iterator3 = _createForOfIteratorHelper(topic),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _richMetadataRenderer = _step3.value.richMetadataRenderer;
              var _meta = _richMetadataRenderer;
              media.category = getText(_meta.title);
              media.category_url = new URL(_meta.endpoint.commandMetadata.webCommandMetadata.url, BASE_URL).toString();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } catch (err) {// Do nothing.
  }

  return media;
};

var isVerified = function isVerified(badges) {
  return !!(badges && badges.find(function (b) {
    return b.metadataBadgeRenderer.tooltip === 'Verified';
  }));
};
/**
 * Get video author.
 *
 * @param {Object} info
 * @returns {Object}
 */


exports.getAuthor = function (info) {
  var channelId,
      thumbnails = [],
      subscriberCount,
      verified = false;

  try {
    var results = info.response.contents.twoColumnWatchNextResults.results.results.contents;
    var v = results.find(function (v2) {
      return v2.videoSecondaryInfoRenderer && v2.videoSecondaryInfoRenderer.owner && v2.videoSecondaryInfoRenderer.owner.videoOwnerRenderer;
    });
    var videoOwnerRenderer = v.videoSecondaryInfoRenderer.owner.videoOwnerRenderer;
    channelId = videoOwnerRenderer.navigationEndpoint.browseEndpoint.browseId;
    thumbnails = videoOwnerRenderer.thumbnail.thumbnails.map(function (thumbnail) {
      thumbnail.url = new URL(thumbnail.url, BASE_URL).toString();
      return thumbnail;
    });
    subscriberCount = utils.parseAbbreviatedNumber(getText(videoOwnerRenderer.subscriberCountText));
    verified = isVerified(videoOwnerRenderer.badges);
  } catch (err) {// Do nothing.
  }

  try {
    var videoDetails = info.player_response.microformat && info.player_response.microformat.playerMicroformatRenderer;
    var id = videoDetails && videoDetails.channelId || channelId || info.player_response.videoDetails.channelId;
    var author = {
      id: id,
      name: videoDetails ? videoDetails.ownerChannelName : info.player_response.videoDetails.author,
      user: videoDetails ? videoDetails.ownerProfileUrl.split('/').slice(-1)[0] : null,
      channel_url: "https://www.youtube.com/channel/".concat(id),
      external_channel_url: videoDetails ? "https://www.youtube.com/channel/".concat(videoDetails.externalChannelId) : '',
      user_url: videoDetails ? new URL(videoDetails.ownerProfileUrl, BASE_URL).toString() : '',
      thumbnails: thumbnails,
      verified: verified,
      subscriber_count: subscriberCount
    };

    if (thumbnails.length) {
      utils.deprecate(author, 'avatar', author.thumbnails[0].url, 'author.avatar', 'author.thumbnails[0].url');
    }

    return author;
  } catch (err) {
    return {};
  }
};

var parseRelatedVideo = function parseRelatedVideo(details, rvsParams) {
  if (!details) return;

  try {
    var viewCount = getText(details.viewCountText);
    var shortViewCount = getText(details.shortViewCountText);
    var rvsDetails = rvsParams.find(function (elem) {
      return elem.id === details.videoId;
    });

    if (!/^\d/.test(shortViewCount)) {
      shortViewCount = rvsDetails && rvsDetails.short_view_count_text || '';
    }

    viewCount = (/^\d/.test(viewCount) ? viewCount : shortViewCount).split(' ')[0];
    var browseEndpoint = details.shortBylineText.runs[0].navigationEndpoint.browseEndpoint;
    var channelId = browseEndpoint.browseId;
    var name = getText(details.shortBylineText);
    var user = (browseEndpoint.canonicalBaseUrl || '').split('/').slice(-1)[0];
    var video = {
      id: details.videoId,
      title: getText(details.title),
      published: getText(details.publishedTimeText),
      author: _defineProperty({
        id: channelId,
        name: name,
        user: user,
        channel_url: "https://www.youtube.com/channel/".concat(channelId),
        user_url: "https://www.youtube.com/user/".concat(user),
        thumbnails: details.channelThumbnail.thumbnails.map(function (thumbnail) {
          thumbnail.url = new URL(thumbnail.url, BASE_URL).toString();
          return thumbnail;
        }),
        verified: isVerified(details.ownerBadges)
      }, Symbol.toPrimitive, function () {
        console.warn("`relatedVideo.author` will be removed in a near future release, " + "use `relatedVideo.author.name` instead.");
        return video.author.name;
      }),
      short_view_count_text: shortViewCount.split(' ')[0],
      view_count: viewCount.replace(/,/g, ''),
      length_seconds: details.lengthText ? Math.floor(parseTimestamp(getText(details.lengthText)) / 1000) : rvsParams && "".concat(rvsParams.length_seconds),
      thumbnails: details.thumbnail.thumbnails,
      richThumbnails: details.richThumbnail ? details.richThumbnail.movingThumbnailRenderer.movingThumbnailDetails.thumbnails : [],
      isLive: !!(details.badges && details.badges.find(function (b) {
        return b.metadataBadgeRenderer.label === 'LIVE NOW';
      }))
    };
    utils.deprecate(video, 'author_thumbnail', video.author.thumbnails[0].url, 'relatedVideo.author_thumbnail', 'relatedVideo.author.thumbnails[0].url');
    utils.deprecate(video, 'ucid', video.author.id, 'relatedVideo.ucid', 'relatedVideo.author.id');
    utils.deprecate(video, 'video_thumbnail', video.thumbnails[0].url, 'relatedVideo.video_thumbnail', 'relatedVideo.thumbnails[0].url');
    return video;
  } catch (err) {// Skip.
  }
};
/**
 * Get related videos.
 *
 * @param {Object} info
 * @returns {Array.<Object>}
 */


exports.getRelatedVideos = function (info) {
  var rvsParams = [],
      secondaryResults = [];

  try {
    rvsParams = info.response.webWatchNextResponseExtensionData.relatedVideoArgs.split(',').map(function (e) {
      return qs.parse(e);
    });
  } catch (err) {// Do nothing.
  }

  try {
    secondaryResults = info.response.contents.twoColumnWatchNextResults.secondaryResults.secondaryResults.results;
  } catch (err) {
    return [];
  }

  var videos = [];

  var _iterator4 = _createForOfIteratorHelper(secondaryResults || []),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var result = _step4.value;
      var details = result.compactVideoRenderer;

      if (details) {
        var video = parseRelatedVideo(details, rvsParams);
        if (video) videos.push(video);
      } else {
        var autoplay = result.compactAutoplayRenderer || result.itemSectionRenderer;
        if (!autoplay || !Array.isArray(autoplay.contents)) continue;

        var _iterator5 = _createForOfIteratorHelper(autoplay.contents),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var content = _step5.value;

            var _video = parseRelatedVideo(content.compactVideoRenderer, rvsParams);

            if (_video) videos.push(_video);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return videos;
};
/**
 * Get like count.
 *
 * @param {Object} info
 * @returns {number}
 */


exports.getLikes = function (info) {
  try {
    var contents = info.response.contents.twoColumnWatchNextResults.results.results.contents;
    var video = contents.find(function (r) {
      return r.videoPrimaryInfoRenderer;
    });
    var buttons = video.videoPrimaryInfoRenderer.videoActions.menuRenderer.topLevelButtons;
    var like = buttons.find(function (b) {
      return b.toggleButtonRenderer && b.toggleButtonRenderer.defaultIcon.iconType === 'LIKE';
    });
    return parseInt(like.toggleButtonRenderer.defaultText.accessibility.accessibilityData.label.replace(/\D+/g, ''));
  } catch (err) {
    return null;
  }
};
/**
 * Get dislike count.
 *
 * @param {Object} info
 * @returns {number}
 */


exports.getDislikes = function (info) {
  try {
    var contents = info.response.contents.twoColumnWatchNextResults.results.results.contents;
    var video = contents.find(function (r) {
      return r.videoPrimaryInfoRenderer;
    });
    var buttons = video.videoPrimaryInfoRenderer.videoActions.menuRenderer.topLevelButtons;
    var dislike = buttons.find(function (b) {
      return b.toggleButtonRenderer && b.toggleButtonRenderer.defaultIcon.iconType === 'DISLIKE';
    });
    return parseInt(dislike.toggleButtonRenderer.defaultText.accessibility.accessibilityData.label.replace(/\D+/g, ''));
  } catch (err) {
    return null;
  }
};
/**
 * Cleans up a few fields on `videoDetails`.
 *
 * @param {Object} videoDetails
 * @param {Object} info
 * @returns {Object}
 */


exports.cleanVideoDetails = function (videoDetails, info) {
  videoDetails.thumbnails = videoDetails.thumbnail.thumbnails;
  delete videoDetails.thumbnail;
  utils.deprecate(videoDetails, 'thumbnail', {
    thumbnails: videoDetails.thumbnails
  }, 'videoDetails.thumbnail.thumbnails', 'videoDetails.thumbnails');
  videoDetails.description = videoDetails.shortDescription || getText(videoDetails.description);
  delete videoDetails.shortDescription;
  utils.deprecate(videoDetails, 'shortDescription', videoDetails.description, 'videoDetails.shortDescription', 'videoDetails.description'); // Use more reliable `lengthSeconds` from `playerMicroformatRenderer`.

  videoDetails.lengthSeconds = info.player_response.microformat && info.player_response.microformat.playerMicroformatRenderer.lengthSeconds || info.player_response.videoDetails.lengthSeconds;
  return videoDetails;
};
/**
 * Get storyboards info.
 *
 * @param {Object} info
 * @returns {Array.<Object>}
 */


exports.getStoryboards = function (info) {
  var parts = info.player_response.storyboards && info.player_response.storyboards.playerStoryboardSpecRenderer && info.player_response.storyboards.playerStoryboardSpecRenderer.spec && info.player_response.storyboards.playerStoryboardSpecRenderer.spec.split('|');
  if (!parts) return [];
  var url = new URL(parts.shift());
  return parts.map(function (part, i) {
    var _part$split = part.split('#'),
        _part$split2 = _slicedToArray(_part$split, 8),
        thumbnailWidth = _part$split2[0],
        thumbnailHeight = _part$split2[1],
        thumbnailCount = _part$split2[2],
        columns = _part$split2[3],
        rows = _part$split2[4],
        interval = _part$split2[5],
        nameReplacement = _part$split2[6],
        sigh = _part$split2[7];

    url.searchParams.set('sigh', sigh);
    thumbnailCount = parseInt(thumbnailCount, 10);
    columns = parseInt(columns, 10);
    rows = parseInt(rows, 10);
    var storyboardCount = Math.ceil(thumbnailCount / (columns * rows));
    return {
      templateUrl: url.toString().replace('$L', i).replace('$N', nameReplacement),
      thumbnailWidth: parseInt(thumbnailWidth, 10),
      thumbnailHeight: parseInt(thumbnailHeight, 10),
      thumbnailCount: thumbnailCount,
      interval: parseInt(interval, 10),
      columns: columns,
      rows: rows,
      storyboardCount: storyboardCount
    };
  });
};
/**
 * Get chapters info.
 *
 * @param {Object} info
 * @returns {Array.<Object>}
 */


exports.getChapters = function (info) {
  var playerOverlayRenderer = info.response && info.response.playerOverlays && info.response.playerOverlays.playerOverlayRenderer;
  var playerBar = playerOverlayRenderer && playerOverlayRenderer.decoratedPlayerBarRenderer && playerOverlayRenderer.decoratedPlayerBarRenderer.decoratedPlayerBarRenderer && playerOverlayRenderer.decoratedPlayerBarRenderer.decoratedPlayerBarRenderer.playerBar;
  var markersMap = playerBar && playerBar.multiMarkersPlayerBarRenderer && playerBar.multiMarkersPlayerBarRenderer.markersMap;
  var marker = Array.isArray(markersMap) && markersMap.find(function (m) {
    return m.value && Array.isArray(m.value.chapters);
  });
  if (!marker) return [];
  var chapters = marker.value.chapters;
  return chapters.map(function (chapter) {
    return {
      title: getText(chapter.chapterRenderer.title),
      start_time: chapter.chapterRenderer.timeRangeStartMillis / 1000
    };
  });
};